<template>
  <div style="text-align: center;padding: 20px 0 30px;height:500px;">
    <img src="@/assets/img/organization.png" alt="组织架构" style="max-width: 100%">
  </div>
</template>

<script>
export default {
  name: "organization",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>
